import { makeSelectors } from '@utils/css';

const transitionDurationMs = {
  enter: 375,
  exit: 300
};
const backdropCls = "dibblfyivb";
const contentCls = "dibc1edntar";
const panelCls = "dibp1827k3y";
const selectors = makeSelectors({
  backdrop: backdropCls,
  content: contentCls,
  panel: panelCls
});

export { backdropCls, contentCls, panelCls, selectors, transitionDurationMs };
import "./panel.style.linaria.module.css";
//# sourceMappingURL=panel.style.js.map
